import { Menu, MenuDivider, MenuItem } from "@chakra-ui/react";
import useStore from "stores/index";
import { getFeatureFlags } from "stores/featureTogglesStore";
import { useUserSessionStore } from "stores/v2/userSessionStore";
import React, { FC, useEffect, useState } from "react";
import { useMatch, useNavigate } from "react-router-dom";

const CurrentUserPopup: FC = () => {
	const navigate = useNavigate();
	const [user, changeUser] = useState("");

	const handleLogout = () => {
		navigate("/login");
	};

	const handleChange = () => {
		const teacherId = useUserSessionStore.getState().getActiveUser();
		if (teacherId) {
			changeUser(teacherId);
		}
	};

	const toggleDisplayNameModal = useStore((state) => state.chat.toggleDisplayNameModal);

	const handleChatSettings = () => {
		toggleDisplayNameModal(true, true);
	};

	useEffect(() => {
		handleChange();

		const unsubUserSessionStore = useUserSessionStore.subscribe(handleChange);
		return () => {
			unsubUserSessionStore();
		};
	}, []);

	/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access*/
	const featureFlags = getFeatureFlags(useStore.getState());
	const isChatEnabled = featureFlags && featureFlags["classwize-teacher-student-chat"];
	/* eslint-enable */

	const inClassroom = !!useMatch("/classroom/:classId");

	const hasChatError = useStore((state) => state.chat.chatError);

	return (
		<Menu>
			<div className="CurrentUserIconPopup">
				<MenuItem>{user}</MenuItem>
				{inClassroom && isChatEnabled && !hasChatError && (
					<MenuItem className="CurrentUserIcon_ChatSettings" onClick={handleChatSettings}>
						<svg
							className="CurrentUserIcon_ChatSettingsIcon"
							width="16"
							height="16"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M13.6733 7.70354C13.6514 7.61667 13.6008 7.53976 13.5296 7.48531C13.4585 7.43087 13.371 7.40209 13.2815 7.40366C13.0084 7.40665 12.741 7.32655 12.5146 7.17398C12.2881 7.02142 12.1135 6.8036 12.0137 6.54945C11.914 6.29529 11.8939 6.01681 11.9561 5.75098C12.0184 5.48514 12.16 5.24451 12.3622 5.06103C12.4252 5.00323 12.4641 4.92371 12.4709 4.83843C12.4777 4.75316 12.452 4.66847 12.3989 4.60138C12.1152 4.24068 11.7913 3.91353 11.4333 3.62629C11.3659 3.57232 11.2803 3.54614 11.1942 3.55309C11.1081 3.56004 11.0278 3.5996 10.9699 3.6637C10.7784 3.86458 10.5317 4.00425 10.2609 4.06506C9.99006 4.12588 9.70732 4.10513 9.4483 4.00542C9.19128 3.89673 8.97414 3.71126 8.8266 3.4744C8.67906 3.23754 8.60834 2.96087 8.6241 2.68227C8.62919 2.59595 8.60101 2.51097 8.54534 2.44481C8.48968 2.37865 8.41077 2.33634 8.32485 2.32659C7.86999 2.2736 7.41061 2.27211 6.95541 2.32216C6.87077 2.33214 6.79298 2.37362 6.73753 2.43835C6.68208 2.50308 6.65303 2.58631 6.65617 2.67149C6.66579 2.94769 6.5908 3.22023 6.44123 3.45263C6.29166 3.68502 6.07466 3.86617 5.81929 3.97182C5.56169 4.06807 5.28155 4.08682 5.01342 4.02576C4.74529 3.9647 4.5009 3.82649 4.31037 3.62819C4.25267 3.56511 4.17331 3.52609 4.08811 3.51892C4.00292 3.51176 3.91816 3.53696 3.85072 3.58952C3.48565 3.87548 3.15464 4.20244 2.86422 4.56398C2.8101 4.6313 2.7837 4.71674 2.79041 4.80287C2.79713 4.88899 2.83645 4.96931 2.90036 5.02743C3.10757 5.21466 3.25164 5.46152 3.31272 5.73402C3.37381 6.00652 3.34891 6.29126 3.24145 6.54903C3.1263 6.80189 2.93893 7.01506 2.70294 7.16171C2.46694 7.30836 2.19284 7.38196 1.91513 7.37322C1.82908 7.36756 1.7442 7.39563 1.67851 7.4515C1.61282 7.50737 1.57148 7.58663 1.56326 7.67247C1.51065 8.13295 1.51065 8.59792 1.56326 9.05839C1.58645 9.14599 1.63848 9.22322 1.71094 9.27762C1.78341 9.33203 1.87209 9.36044 1.96268 9.35827C2.23143 9.35522 2.49485 9.43326 2.71857 9.58222C2.94228 9.73117 3.11589 9.94412 3.21672 10.1933C3.32014 10.4493 3.34289 10.7308 3.28193 11.0001C3.22098 11.2694 3.07922 11.5137 2.87563 11.7003C2.81274 11.758 2.77401 11.8374 2.76719 11.9226C2.76037 12.0077 2.78597 12.0922 2.83886 12.1593C3.12236 12.5196 3.44587 12.8465 3.80317 13.1337C3.87062 13.188 3.95625 13.2144 4.04252 13.2075C4.1288 13.2007 4.2092 13.1611 4.26726 13.097C4.45858 12.8958 4.70531 12.7559 4.97618 12.6951C5.24705 12.6343 5.52989 12.6552 5.78886 12.7552C6.04593 12.8637 6.26316 13.049 6.41072 13.2858C6.55829 13.5226 6.62897 13.7992 6.61306 14.0778C6.60795 14.1641 6.63612 14.2492 6.69177 14.3155C6.74742 14.3817 6.82634 14.4242 6.9123 14.4341C7.3678 14.4872 7.82786 14.4884 8.28364 14.4379C8.36875 14.4285 8.44716 14.3873 8.50313 14.3225C8.5591 14.2577 8.5885 14.1741 8.58543 14.0885C8.5755 13.8128 8.65002 13.5406 8.79901 13.3083C8.94799 13.076 9.16435 12.8948 9.41913 12.7888C9.67677 12.6921 9.95713 12.6731 10.2255 12.7342C10.4938 12.7953 10.7383 12.9338 10.9287 13.1325C10.9865 13.1956 11.066 13.2346 11.1513 13.2418C11.2366 13.249 11.3214 13.2237 11.389 13.1711C11.7538 12.8849 12.0846 12.5577 12.3748 12.1961C12.4291 12.1288 12.4556 12.0433 12.4489 11.9571C12.4422 11.871 12.4027 11.7906 12.3387 11.7326C12.1314 11.5454 11.9872 11.2986 11.926 11.0261C11.8648 10.7536 11.8896 10.4688 11.997 10.211C12.1021 9.96718 12.2761 9.75932 12.4976 9.61292C12.7191 9.46652 12.9785 9.38794 13.244 9.3868H13.3195C13.4058 9.39194 13.4909 9.36388 13.5573 9.30837C13.6236 9.25286 13.6662 9.1741 13.6764 9.08819C13.7279 8.62802 13.7269 8.16347 13.6733 7.70354ZM7.62682 10.4259C7.22466 10.4261 6.83149 10.3069 6.49704 10.0836C6.1626 9.86024 5.90189 9.54273 5.7479 9.17122C5.59392 8.79971 5.55356 8.39087 5.63194 7.99642C5.71032 7.60197 5.90392 7.23962 6.18825 6.95521C6.47258 6.67079 6.83486 6.47708 7.22929 6.39857C7.62371 6.32007 8.03256 6.3603 8.40412 6.51417C8.77569 6.66804 9.09327 6.92865 9.31671 7.26302C9.54016 7.5974 9.65942 7.99053 9.65942 8.39269C9.65892 8.93168 9.44463 9.44845 9.06357 9.82963C8.68251 10.2108 8.1658 10.4253 7.62682 10.4259Z"
								fill="#0075DB"
							/>
						</svg>
						Chat Settings
					</MenuItem>
				)}
				<MenuDivider />
				<MenuItem onClick={handleLogout} className="CurrentUserIconPopup_signOutButton">
					Sign out
				</MenuItem>
			</div>
		</Menu>
	);
};

export default CurrentUserPopup;
